(function () {
  if (window.__ampSlidecartTranslationsInitialized) return;
  window.__ampSlidecartTranslationsInitialized = true;

  var SOURCE_DISCOUNT_TITLE = /^FREE\s*Discovery$/i;

  var DISCOUNT_LABEL_BY_LANG = {
    fr: 'Découverte offerte',
    de: 'Gratis Entdeckung',
    es: 'Descubrimiento gratis',
    it: 'Scoperta gratuita',
    en: 'Free Discovery'
  };

  function getShortLang() {
    var pathMatch = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/i);
    if (pathMatch) return pathMatch[1].toLowerCase();

    var locale =
      (window.Shopify && window.Shopify.locale) ||
      document.documentElement.getAttribute('lang') ||
      '';

    if (locale) return locale.toLowerCase().split('-')[0];

    return 'fr';
  }

  function getDiscountLabel() {
    return DISCOUNT_LABEL_BY_LANG[getShortLang()] || DISCOUNT_LABEL_BY_LANG.en;
  }

  function shouldReplaceDiscountTitle(title) {
    return SOURCE_DISCOUNT_TITLE.test(String(title || '').trim());
  }

  function localizeDiscountTitle(title) {
    if (!shouldReplaceDiscountTitle(title)) return title;
    return getDiscountLabel();
  }

  function patchDiscountApplication(app) {
    if (!app || !app.title) return;
    app.title = localizeDiscountTitle(app.title);
  }

  function patchCartDiscountTitles(cart) {
    if (!cart) return cart;

    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        if (allocation.discount_application) {
          patchDiscountApplication(allocation.discount_application);
        }
      });

      (item.discounts || []).forEach(function (discount) {
        if (discount.title) discount.title = localizeDiscountTitle(discount.title);
      });
    });

    (cart.cart_level_discount_applications || []).forEach(patchDiscountApplication);

    return cart;
  }

  function patchCartResponseText(text) {
    if (!text || text.indexOf('FREE') === -1) return text;

    try {
      var cart = JSON.parse(text);
      return JSON.stringify(patchCartDiscountTitles(cart));
    } catch (e) {
      return text;
    }
  }

  function isCartDataRequest(url) {
    var value = String(url || '');
    return /\/cart(\.js)?([?#]|$)/.test(value) && !/\/cart\/add/.test(value);
  }

  function patchFetch() {
    var nativeFetch = window.fetch;
    if (!nativeFetch || nativeFetch.__ampDiscountTitlePatch) return;

    function patchedFetch(input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var responsePromise = nativeFetch.apply(this, arguments);

      if (!isCartDataRequest(url)) return responsePromise;

      return responsePromise.then(function (response) {
        if (!response.ok) return response;

        return response
          .clone()
          .text()
          .then(function (text) {
            var patched = patchCartResponseText(text);
            if (patched === text) return response;

            return new Response(patched, {
              status: response.status,
              statusText: response.statusText,
              headers: response.headers
            });
          })
          .catch(function () {
            return response;
          });
      });
    }

    patchedFetch.__ampDiscountTitlePatch = true;
    window.fetch = patchedFetch;
  }

  function patchXHR() {
    if (window.XMLHttpRequest.prototype.__ampDiscountTitlePatch) return;

    var nativeOpen = window.XMLHttpRequest.prototype.open;
    var nativeSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__ampCartUrl = url;
      return nativeOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      var xhr = this;

      if (isCartDataRequest(xhr.__ampCartUrl)) {
        xhr.addEventListener('load', function () {
          if (xhr.status < 200 || xhr.status >= 300) return;

          try {
            var original = xhr.responseText;
            var patched = patchCartResponseText(original);
            if (patched === original) return;

            Object.defineProperty(xhr, 'responseText', { value: patched });
            Object.defineProperty(xhr, 'response', { value: patched });
          } catch (e) {}
        });
      }

      return nativeSend.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.__ampDiscountTitlePatch = true;
  }

  function patchSlideCartState() {
    if (typeof window.SLIDECART_STATE !== 'function' || window.SLIDECART_STATE.__ampDiscountTitlePatch) return;

    var original = window.SLIDECART_STATE;

    window.SLIDECART_STATE = function () {
      var state = original();
      if (state && state.cart) patchCartDiscountTitles(state.cart);
      return state;
    };

    window.SLIDECART_STATE.__ampDiscountTitlePatch = true;
  }

  var isUpdatingTranslations = false;

  function updateUpsellButtons(root) {
    if (getShortLang() !== 'fr') return;

    var upsells = root.querySelector('.upsells');
    if (!upsells) return;

    upsells.querySelectorAll('button, .button, a.button').forEach(function (el) {
      if (el.textContent.trim() === 'Add') el.textContent = 'Ajouter';
    });
  }

  function updateDiscountLabelsInDom(root) {
    var label = getDiscountLabel();

    root.querySelectorAll('.item .savings-text, .savings-text').forEach(function (el) {
      if (shouldReplaceDiscountTitle(el.textContent)) {
        el.textContent = label;
      }
    });
  }

  function updateTranslations() {
    var root = document.getElementById('slidecarthq');
    if (!root) return;

    isUpdatingTranslations = true;
    updateUpsellButtons(root);
    updateDiscountLabelsInDom(root);
    isUpdatingTranslations = false;
  }

  var translationUpdateTimer;

  function scheduleUpdate() {
    window.clearTimeout(translationUpdateTimer);
    translationUpdateTimer = window.setTimeout(updateTranslations, 0);
  }

  function observeSlideCart() {
    var root = document.getElementById('slidecarthq');
    if (!root || root.__ampTranslationsObserver) return;

    root.__ampTranslationsObserver = new MutationObserver(function () {
      if (isUpdatingTranslations) return;
      scheduleUpdate();
    });

    root.__ampTranslationsObserver.observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function chainCallback(name, fn) {
    var previous = window[name];
    window[name] = function () {
      if (typeof previous === 'function') previous.apply(this, arguments);
      fn.apply(this, arguments);
    };
  }

  function bootstrap() {
    observeSlideCart();
    scheduleUpdate();
  }

  patchFetch();
  patchXHR();
  patchSlideCartState();

  chainCallback('SLIDECART_LOADED', bootstrap);
  chainCallback('SLIDECART_UPDATED', scheduleUpdate);
  chainCallback('SLIDECART_OPENED', scheduleUpdate);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
